module.exports = __webpack_public_path__ + "static/media/tamtam.5db87e69.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/tamtam.woff?cciqt6
// module id = 658
// module chunks = 0